module.exports = __webpack_public_path__ + "static/img/ratio2.bace862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2-coupon/ratio2.png
// module id = 6loj
// module chunks = 13